export default __webpack_public_path__ + "static/media/euro.3d1375c4.svg";